(() => {
  'use strict';

  const widget = document.querySelector('[data-eotl-accessibility]');
  if (!widget) return;

  const root = document.documentElement;
  const trigger = widget.querySelector('[data-eotl-a11y-trigger]');
  const panel = widget.querySelector('[data-eotl-a11y-panel]');
  const closeButton = widget.querySelector('[data-eotl-a11y-close]');
  const status = widget.querySelector('[data-eotl-a11y-status]');
  const textOutput = widget.querySelector('[data-eotl-a11y-text-output]');
  const storageKey = 'eotl-accessibility-preferences-v1';

  const defaults = {
    textScale: 0,
    contrast: false,
    grayscale: false,
    readableFont: false,
    highlightLinks: false,
    textSpacing: false,
    reduceMotion: false
  };

  const classNames = {
    contrast: 'eotl-a11y-contrast',
    grayscale: 'eotl-a11y-grayscale',
    readableFont: 'eotl-a11y-readable-font',
    highlightLinks: 'eotl-a11y-highlight-links',
    textSpacing: 'eotl-a11y-text-spacing',
    reduceMotion: 'eotl-a11y-reduce-motion'
  };

  let preferences = { ...defaults };

  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
    preferences = { ...preferences, ...saved };
    preferences.textScale = Math.max(0, Math.min(2, Number(preferences.textScale) || 0));
  } catch (error) {
    preferences = { ...defaults };
  }

  const savePreferences = () => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(preferences));
    } catch (error) {
      // Preferences still work for the current page when storage is unavailable.
    }
  };

  const announce = (message) => {
    status.textContent = '';
    window.setTimeout(() => {
      status.textContent = message;
    }, 30);
  };

  const applyPreferences = () => {
    root.dataset.eotlA11yText = String(preferences.textScale);

    Object.entries(classNames).forEach(([preference, className]) => {
      root.classList.toggle(className, Boolean(preferences[preference]));
    });

    widget.querySelectorAll('[data-eotl-a11y-toggle]').forEach((button) => {
      const preference = button.dataset.eotlA11yToggle;
      button.setAttribute('aria-pressed', String(Boolean(preferences[preference])));
    });

    textOutput.textContent = ['Default', 'Large', 'Extra large'][preferences.textScale];
  };

  const setPanelOpen = (open, restoreFocus = false) => {
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
    trigger.setAttribute('aria-label', open ? 'Close accessibility menu' : 'Open accessibility menu');

    if (open) {
      closeButton.focus();
    } else if (restoreFocus) {
      trigger.focus();
    }
  };

  trigger.addEventListener('click', () => {
    setPanelOpen(panel.hidden);
  });

  closeButton.addEventListener('click', () => {
    setPanelOpen(false, true);
  });

  widget.querySelectorAll('[data-eotl-a11y-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const preference = button.dataset.eotlA11yToggle;
      preferences[preference] = !preferences[preference];
      applyPreferences();
      savePreferences();
      announce(`${button.querySelector('.eotl-a11y-option__title').textContent} ${preferences[preference] ? 'on' : 'off'}.`);
    });
  });

  widget.querySelectorAll('[data-eotl-a11y-text]').forEach((button) => {
    button.addEventListener('click', () => {
      const direction = button.dataset.eotlA11yText;
      const change = direction === 'increase' ? 1 : -1;
      preferences.textScale = Math.max(0, Math.min(2, preferences.textScale + change));
      applyPreferences();
      savePreferences();
      announce(`Text size set to ${textOutput.textContent.toLowerCase()}.`);
    });
  });

  widget.querySelector('[data-eotl-a11y-reset]').addEventListener('click', () => {
    preferences = { ...defaults };
    applyPreferences();
    savePreferences();
    announce('All accessibility display settings reset.');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      setPanelOpen(false, true);
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (!panel.hidden && !widget.contains(event.target)) {
      setPanelOpen(false);
    }
  });

  applyPreferences();
})();
